import { Badges, Btn, Image, P } from "../../../AbstractElements";
import { dynamicImage } from "../../../Service";
import { TableColumn } from "react-data-table-component";
import {
  ProductListTableDataColumnType,
  ProductListTableProduct,
} from "../../../Type/Application/Ecommerce/Ecommerce";

export const productListTableData = [
  {
    image: "ecommerce/product-table-1.png",
    name: "Red Shirt",
    amount: 56000.0,
    status: "Sold Out",
    date: "2011/04/25",
  },
  {
    image: "ecommerce/product-table-2.png",
    name: "Apple iphone 13 Pro",
    amount: 19000.0,
    status: "In Stock",
    date: "2011/04/25",
  },
  {
    image: "ecommerce/product-table-3.png",
    name: "Headphones",
    amount: 10000.0,
    status: "In Stock",
    date: "2011/04/25",
  },
  {
    image: "ecommerce/product-table-4.png",
    name: "Wireless-headphone",
    amount: 15000.0,
    status: "Sold Out",
    date: "2011/04/25",
  },
  {
    image: "ecommerce/product-table-5.png",
    name: "Wood Chair",
    amount: 99000.0,
    status: "Sold Out",
    date: "2011/04/25",
  },
  {
    image: "ecommerce/product-table-6.png",
    name: "Wood Chair",
    amount: 1000.0,
    status: "Sold Out",
    date: "2011/04/25",
  },
  {
    image: "ecommerce/product-table-1.png",
    name: "MacBook Air 13.3-inch",
    amount: 45000.0,
    status: "Sold Out",
    date: "2011/04/25",
  },
  {
    image: "ecommerce/product-table-2.png",
    name: "M185 Compact Wireless Mouse",
    amount: 56000.0,
    status: "Sold Out",
    date: "2011/04/25",
  },
  {
    image: "ecommerce/product-table-3.png",
    name: "Wood chairs",
    amount: 78000.0,
    status: "In Stock",
    date: "2011/04/25",
  },
  {
    image: "ecommerce/product-table-4.png",
    name: "Smart watch",
    amount: 25000.0,
    status: "Sold Out",
    date: "2011/04/25",
  },
];

const ProductListTableAction = () => {
  return (
    <div className="d-flex align-items-center gap-2">
      <Btn size="sm" color="danger" >
        Delete
      </Btn>
      <Btn color="success" size="sm">
        Edit
      </Btn>
    </div>
  );
};

const ProductListTableProductName: React.FC<ProductListTableProduct> = ({
  images,
  name,
}) => {
  return (
    <div className="product-names my-2">
      <div>
        <Image className="img-fluid" src={dynamicImage(images)} alt="laptop" />
      </div>
      <P>{name}</P>
    </div>
  );
};

const ProductListTableStatus: React.FC<ProductListTableProduct> = ({
  name,
}) => {
  return (
    <Badges
      color="transparent"
      className={`badge-light-${name === "Sold Out" ? "danger" : "success"}`}
    >
      {name}
    </Badges>
  );
};

const ProductListTableRating: React.FC<ProductListTableProduct> = ({
  date,
}) => {
  return <div>{date}</div>;
};

export const productListTableDataColumn: TableColumn<ProductListTableDataColumnType>[] =
  [
    {
      name: "Image Name",
      cell: (row) => (
        <ProductListTableProductName images={row.image} name={row.name} />
      ),
      sortable: true,
      grow: 2,
    },
    {
      name: "Amount",
      selector: (row) => `${row.amount}`,
      sortable: true,
    },
    {
      name: "Stock",
      cell: (row) => <ProductListTableStatus name={row.status} />,
    },
    {
      name: "Start Date",
      cell: (row) => <ProductListTableRating date={row.date} />,
    },
    {
      name: "Action",
      cell: () => <ProductListTableAction />,
    },
  ];

export const filtersData = [
  {
    name: "Choose Product",
    options: [
      "Apple iphone 13 Pro",
      "Wood Chair",
      "M185 Compact Wireless Mouse",
    ],
  },
  {
    name: "Choose Category",
    options: ["Furniture", "Smart Gadgets", "Electrics"],
  },
  {
    name: "Choose Sub Category",
    options: ["Smart Phones", "Smart Watches", "Wireless headphone"],
  },
  {
    name: "Status",
    options: ["Sold Out", "In Stock", "Pre Order", "Limited Stock"],
  },
  {
    name: "Price",
    options: ["56000.00", "19000.00", "10000.00", "15000.00", "99000.00"],
  },
];

export const productListFilterHeaderData = [
  {
    text: "The searching functionality provided by DataTables is useful for quickly search through the information in the table - however the search is global, and you may wish to present controls that search on specific columns.",
  },
];
